import React from 'react'
import { NavLink } from 'react-router-dom'
import './Navbar.css'
import { Text, Heading } from '@chakra-ui/react'

function Navbar() {
  return (
    <nav className="navBar">
      <div className="nav-brand">
        <Heading as="h1" size="2xl">
          <Text
            bgGradient="linear(to-l, #7928CA,#FF0080)"
            bgClip="text"
            fontWeight="extrabold"
          >
            <NavLink to="/" style={{ textDecoration: 'none' }}>
              {' '}
              <Text
                bgGradient="linear(to-l, #7928CA,#FF0080)"
                bgClip="text"
                fontWeight="extrabold"
              >
                Ibrahim Sowunmi
              </Text>
            </NavLink>
          </Text>
        </Heading>
      </div>
      <div className="nav-links">
        <NavLink to="/blog">Blog</NavLink>
        <span style={{ margin: '0 8px', color: '#D8D0D9' }}>/</span>
        <NavLink to="/art">Art</NavLink>
        {/* <span style={{ margin: '0 8px', color: '#D8D0D9' }}>/</span>
        <NavLink to="/photosets">Photosets</NavLink> */}
        {/* <span style={{ margin: '0 8px', color: '#D8D0D9' }}>/</span>
        <NavLink to="/bookmarks">Bookmarks</NavLink> */}
        <span style={{ margin: '0 8px', color: '#D8D0D9' }}>/</span>
        <NavLink to="/content">Media</NavLink>
      </div>
    </nav>
  )
}

export default Navbar
